import React from 'react';
import { Typography, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PagesStepper from '../PagesStepper';

const useStyles = makeStyles(() => ({
  boxTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },
}));

const WidgetBox = function WidgetBox({
  widget = null,
  title = null,
  titleWidget = null,
  height = null,
  flex = null,
  pages = 1,
  currentPage = 0,
  handleChangePage = null,
}) {
  const classes = useStyles();

  return (
    <Paper
      sx={{
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '18px',
      }}
      style={{ height, flex }}
      elevation={3}
    >
      <div
        className={classes.boxTitle}
        style={{
          borderBottom: title && '1px solid lightgray',
          padding: !title && 0,
        }}
      >
        {title && (
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }} noWrap>
            {title}
          </Typography>
        )}
        {titleWidget}
      </div>
      {widget}
      {pages > 1 && (
        <PagesStepper
          max={pages}
          currentStep={currentPage}
          handleChangeStep={handleChangePage}
        />
      )}
    </Paper>
  );
};

export default WidgetBox;
